import { atom } from '@exodus/headless-ui';
import fromAssetAtom from './from-asset.js';
const INITIAL_AMOUNT = '0';
const fromAmountValueAtom = atom(INITIAL_AMOUNT);
const fromAmountAtom = atom((get) => {
    const fromAmountValue = get(fromAmountValueAtom);
    const fromAsset = get(fromAssetAtom);
    return fromAsset.currency.defaultUnit(fromAmountValue);
}, (get, set, newAmount) => {
    set(fromAmountValueAtom, newAmount?.toDefaultString() ?? INITIAL_AMOUNT);
});
export default fromAmountAtom;
